<h2 class="section-title-with-icon">
  <mat-icon class="section-title-icon notranslate">my_location</mat-icon>
  <span>My Position</span>
</h2>

<ul class="details-list">
  <!-- Shares Percentage -->
  @if(!!position?.totalShares){
  <li class="details-list-item">
    <label>Shares</label>
    <span>
      <span class="value">{{ position.totalShares | terraNumber }} </span>
    </span>
  </li>
  }
  <!-- Ownership Percentage -->
  @if(position?.ownershipPercentage != null){
  <li class="details-list-item">
    <label>Ownership Percentage</label>
    <span>
      <span class="value">{{ position.ownershipPercentage | terraNumber }} </span>
      <span class="unit">%</span>
    </span>
  </li>
  }
  <!-- Total Committed -->
  @if (position?.totalCommited != null) {
  <li class="details-list-item">
    <label>Total Committed</label>
    <span>
      <span class="value">{{ position.totalCommited | terraCurrency }} </span>
      <span class="unit">{{ initialCurrency.iso }}</span>
    </span>
  </li>
  }
  <!-- Total Invested -->
  @if(position?.totalInvested != null && position.totalInvested !== 0){
  <li class="details-list-item">
    <label>{{ holdingSecurityType === InvestmentSecurityType.Debt ? 'Invested Amount' : 'Equity Invested' }}</label>
    <span>
      <span class="value">{{ position.totalInvested | terraCurrency }} </span>
      <span class="unit">{{ initialCurrency.iso }}</span>
    </span>
  </li>
  }
  <!-- Capital returned -->
  @if(position?.totalInvested != null && position.totalInvested !== 0){
  <li class="details-list-item">
    <label>Capital Returned</label>
    <span>
      <span class="value">{{ position.totalInvested - position.principalBalance | terraCurrency }} </span>
      <span class="unit">{{ initialCurrency.iso }}</span>
    </span>
  </li>
  }

  <!-- Principal balance -->
  @if(position?.principalBalance != null && position.totalInvested !== 0){
  <li class="details-list-item">
    <label>{{ holdingSecurityType === InvestmentSecurityType.Debt ? 'Principal Balance' : 'Capital Account' }}</label>
    <span>
      <span class="value">{{ position.principalBalance | terraCurrency }} </span>
      <span class="unit">{{ initialCurrency.iso }}</span>
    </span>
  </li>
  }

  <!-- Return to Date -->
  @if (position?.returnToDate != null) {
  <li class="details-list-item">
    <label>{{ holdingSecurityType === InvestmentSecurityType.Debt ? 'Return to Date' : 'Profit Returned' }}</label>
    <span>
      <span class="value">{{ position.returnToDate | terraCurrency }} </span>
      <span class="unit">{{ initialCurrency.iso }}</span>
    </span>
  </li>
  }

  <!-- Total Distributed -->
  @if(position?.totalDistributed != null) {
  <li class="details-list-item">
    <label>Total Distributed</label>
    <span>
      <span class="value">{{ position.totalDistributed | terraCurrency }} </span>
      <span class="unit">{{ initialCurrency.iso }}</span>
    </span>
  </li>
  }

  <!-- Net Asset Value -->
  @if (position?.netAssetValue != null) {
  <li class="details-list-item">
    <span>
      <label>Net Asset Value</label>
      <mat-icon
        matTooltip="Net Asset Value (NAV) represents the updated value of your investment, factoring in changes in market value and any outstanding loans, calculated based on your ownership percentage. The formula is: (Estimated Market Value - Loan Amount) × Your Ownership Percentage."
        class="notranslate list-item-tooltip" color="primary" matTooltipClass="terra-tooltip"
        matTooltipPosition="right">help
      </mat-icon>
    </span>
    <span>
      <span class="value">{{ position.netAssetValue | terraCurrency }} </span>
      <span class="unit">{{ initialCurrency.iso }}</span>
    </span>
  </li>
  }

  <!-- Equity multiple -->
  @if (displayEquityMultiple && position?.equityMultiple != null) {
  <li class="details-list-item">
    <label>{{includeUnrealizedNav ? "Realized Equity Multiple" : "Equity Multiple"}}</label>
    <span>
      <span class="value">{{ position.equityMultiple | number: '1.2-2' }}x</span>
    </span>
  </li>
  }
  @if (displayEquityMultiple && includeUnrealizedNav && position?.equityMultipleIncludingUnrealizedNav != null) {
    <li class="details-list-item">
      <label>Equity Multiple Including unrealized NAV</label>
      <span>
        <span class="value">{{ position.equityMultipleIncludingUnrealizedNav | number: '1.2-2' }}x</span>
      </span>
    </li>
  }
  @if (includeUnrealizedNav && displayIrr && position?.irrPercentageIncludingUnrealizedNav != null) {
    <li class="details-list-item">
      <label>IRR Including unrealized NAV</label>
      <span>
        <span class="value">{{ position.irrPercentageIncludingUnrealizedNav }} </span>
        <span class="unit">%</span>
      </span>
    </li>
  }
  @if (displayIrr && !includeUnrealizedNav && position?.irrPercentage != null) {
  <li class="details-list-item">
    <label>IRR</label>
    <span>
      <span class="value">{{ position.irrPercentage }} </span>
      <span class="unit">%</span>
    </span>
  </li>
  }
  @if (displayIrr && !includeUnrealizedNav && position?.adjustedIrrPercentage != null) {
  <li class="details-list-item">
    <label>Adjusted IRR</label>
    <span>
      <span class="value">{{ position.adjustedIrrPercentage }} </span>
      <span class="unit">%</span>
    </span>
  </li>
  }
  @if (displayCashOnCash && position?.cashOnCashRatePercentage != null) {
  <li class="details-list-item">
    <label>Cash on Cash</label>
    <span>
      <span class="value">{{ position.cashOnCashRatePercentage }} </span>
      <span class="unit">%</span>
    </span>
  </li>
  }
</ul>